import React, { useState, useEffect } from "react";
import { Area, Line } from "@ant-design/plots";
import {
  usePlayerPPRMutation,
  usePlayerSPRMutation,
  usePlayerRankMutation,
} from "../../services/playerApi";
import { useSelector } from "react-redux";
import * as Global from "../../styles/Global";
import { Text } from "../../styles/Global";

const AreaPlot = ({ data, style, type, x, y, customConfig }) => {
  //console.log("areadata: ", data);

  const config = customConfig
    ? customConfig
    : {
        data,
        xField: x,
        yField: y,
        xAxis: {
          tickCount: 10,
        },
        meta: {
          spr: {
            min: Math.min.apply(
              Math,
              data.map(function (o) {
                return o.spr - 2;
              })
            ),
            max: Math.max.apply(
              Math,
              data.map(function (o) {
                return o.spr + 2;
              })
            ),
          },
          rank: {
            min: 1,
            range: [1, 0],
          },
        },
        legend: {
          slidable: true,
        },
        smooth: true,
        animation: true,
        slider: {
          start: 0,
          end: 10,
          trendCfg: {
            isArea: true,
          },
        },
      };

  return data && data.length > 0 ? (
    <Area style={(style, { paddingTop: 20 })} {...config} />
  ) : null;
};

export default AreaPlot;
